<template>
  <b-embed
           type="iframe"
           aspect="16by9"
           :src="url"
           allowfullscreen
  ></b-embed>
</template>
<script>
  import parser from 'js-video-url-parser'

  export default {
    props: {
      src: {
        required: true,
        type: String
      }
    },
    data() {
      return {
        url: '',
        video: {}
      }
    },
    watch: {
      src() {
        this.parseSrc()
      }
    },
    created() {
      this.parseSrc()
    },
    methods: {
      parseSrc() {
        this.video = parser.parse(this.src)
        if (!this.video) {
          this.url = ''
          return
        }

        this.url = parser.create({
          videoInfo: this.video,
          format: 'embed'
        })
      }
    }
  }
</script>